'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIButton from 'UIComponents/button/UIButton';
import H2 from 'UIComponents/elements/headings/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const langKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.automation.marketingContacts.disableModal.${key}`;
const Header = ({
  formName
}) => /*#__PURE__*/_jsx(UIDialogHeader, {
  children: /*#__PURE__*/_jsx(H2, {
    className: "text-left",
    weight: "bold",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey('header'),
      options: {
        formName
      }
    })
  })
});
const Body = () => /*#__PURE__*/_jsx(UIDialogBody, {
  children: /*#__PURE__*/_jsx("div", {
    className: "text-left m-top-4",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey('body')
    })
  })
});
const Footer = ({
  onConfirm,
  onCancel
}) => /*#__PURE__*/_jsxs(UIDialogFooter, {
  children: [/*#__PURE__*/_jsx(UIButton, {
    use: "danger",
    onClick: onConfirm,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey('confirm')
    })
  }), /*#__PURE__*/_jsx(UIButton, {
    use: "tertiary-light",
    onClick: onCancel,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cancel"
    })
  })]
});
const MarketableContactsWarningModal = ({
  formName,
  onConfirm,
  onCancel
}) => /*#__PURE__*/_jsxs(UIModal, {
  use: "danger",
  width: 550,
  children: [/*#__PURE__*/_jsx(Header, {
    formName: formName
  }), /*#__PURE__*/_jsx(Body, {}), /*#__PURE__*/_jsx(Footer, {
    onConfirm: onConfirm,
    onCancel: onCancel
  })]
});
export default MarketableContactsWarningModal;